import { AbstractControl, ValidatorFn } from '@angular/forms';

export const freeEmailRegex =
  /gmail|yahoo|hotmail|outlook|msn|aol|yandex|protonmail|zohomail|tutanota|tutamail|tuta|keemail|icloud/gi;

export function emailProviderValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const forbidden = String(control.value)
      .split('@')[1]
      ?.match(freeEmailRegex);
    return forbidden ? { emailprovider: { value: control.value } } : null;
  };
}
